import { useState, MouseEvent } from 'react';
import { UseFormHandleSubmit, FieldErrors } from 'react-hook-form';
import { isEmpty } from 'lodash';
import { Notification } from 'Components';
import { Values } from '../../GroupsHierarchy.types';
import { useGroupsHierarchyContext } from '../../GroupsHierarchyContext';
import { DELAY_TIME } from '../../GroupsHierarchy.constants';
import { prepareValues } from '../../GroupsHierarchy.helpers';
import HierarchySubmitButton from '../HierarchySubmitButton/HierarchySubmitButton';

interface HierarchyFormSubmitButtonProps {
	handleSubmit: UseFormHandleSubmit<Values>;
	errors: FieldErrors<Values>;
}

const HierarchyFormSubmitButton = ({
	handleSubmit,
	errors
}: HierarchyFormSubmitButtonProps) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const {
		changeScreenType,
		parent,
		levelNumber
	} = useGroupsHierarchyContext();

	const handleSubmitButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
		setIsSubmitting(true);
		// timeout needs for rendering a spinner when form submitting huge amount of groups
		setTimeout(() => {
			handleSubmit(onSubmit, onError)(e);
		}, DELAY_TIME);
	};

	const onSubmit = (values: Values) => {
		if (parent) {
			const hierarchyGroups = prepareValues(values, parent);
			setIsSubmitting(false);
			changeScreenType('manage-hierarchy', hierarchyGroups);
		}
	};

	const onError = (errors: FieldErrors<Values>) => {
		setIsSubmitting(false);
		
		// Check if there are missing hierarchyLabel errors
		const missingLabels: string[] = [];
		Object.keys(errors).forEach((levelKey) => {
			const levelErrors = errors[levelKey as keyof Values];
			if (levelErrors && typeof levelErrors === 'object') {
				if ('hierarchyLabel' in levelErrors) {
					const levelNumber = levelKey.replace('level', '');
					missingLabels.push(`Level ${levelNumber}`);
				}
			}
		});

		if (missingLabels.length > 0) {
			Notification.error({
				description: `Please select a Type for ${missingLabels.join(', ')} before proceeding.`,
				duration: 8
			});
		}
	};

	const disableSubmitButton =
		levelNumber === parent?.level || !isEmpty(errors);
	return (
		<HierarchySubmitButton
			disabled={disableSubmitButton}
			onClick={handleSubmitButtonClick}
			loading={isSubmitting}
		/>
	);
};

export default HierarchyFormSubmitButton;
